import type { ReadonlyURLSearchParams } from 'next/navigation';

export function updateUrlQueryParams(
	newParams: Record<string, string | number | boolean | undefined | null>
): string {
	const url = new URL(window.location.href);

	Object.entries(newParams).forEach(([key, value]) => {
		if (value === undefined || value === null) {
			url.searchParams.delete(key);
		} else {
			url.searchParams.set(key, String(value));
		}
	});

	return url.toString();
}

export function updateQueryParams(
	newParams: Record<
		string,
		string | number | boolean | undefined | null | string[]
	>,
	searchParams: ReadonlyURLSearchParams
) {
	const urlSearchParams = new URLSearchParams(searchParams);
	Object.entries(newParams).forEach(([key, value]) => {
		if (value === undefined || value === null) {
			urlSearchParams.delete(key);
		} else if (Array.isArray(value)) {
			urlSearchParams.delete(key);
			value.forEach((item) => {
				urlSearchParams.append(key, String(item));
			});
		} else {
			urlSearchParams.set(key, String(value));
		}
	});

	return urlSearchParams.toString();
}

export const updateQueryParamsWithPathname = (
	newParams: Record<
		string,
		string | number | boolean | undefined | null | string[]
	>,
	pathname: string,
	searchParams: ReadonlyURLSearchParams
) => {
	const params = updateQueryParams(newParams, searchParams);
	if (params) {
		return `${pathname}?${params}`;
	} else {
		return pathname;
	}
};
